import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { loginActions } from "../features/Login/actions/LoginAction"; //tokenManager/actions/tokenManagerActions";
import {masteruri} from "../config";
import { TokenModel } from "../features/Login/typing/generalLoginType";
import { message } from "antd";

export const getToken = async (username: string, password: string)=>{
            const token = await fetch(masteruri+"/users/authenticate",{
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: {
                    "Content-Type": "text/json", //"text/plain",
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': 'Basic ' + btoa(username+":"+password),
                },
                body: JSON.stringify({
                    data:{
                        Username:username,
                        Password:password,
                    }
                  }),
            })
            .then(
                (response:Response) => {
                    //console.log(response.body) //FIXME: REMOVE BEFORE RELEASE
                    return response.json();
                },(problem:any) => {
                    console.log("There was a problem fetching the token", problem);
                })
            .then((tokenpayload:{token:TokenModel}) => {
                
                loginActions.doLogin({Token:tokenpayload.token});
                return tokenpayload.token;
            })
            return token;  
   
}

/**
 * Reads a 2xx body. An empty body is a success without payload (null), not a
 * parse error - some endpoints answer 200 with nothing in it.
 */
export async function readBody(response: Response): Promise<any> {
    const text = await response.text();
    return text.trim() === "" ? null : JSON.parse(text);
}

/**
 * What an answer means. A total function over the status code: every input maps
 * to a case, including the ones nobody thought of.
 *
 * Pulled out of the request so it can be judged on its own. Until 21.09.2026 the
 * request made this decision in passing and had no case for "failed" at all - a
 * non-2xx answer fell through every branch, the payload stayed undefined and the
 * callbacks were never reached. The page kept its loading skeleton and said
 * nothing, for ever. That is how GET /api/Scriptvault could answer 405 for years
 * without anyone seeing an error.
 *
 * "empty" (since 27.09.2026): 204 and 205 carry no body by definition. Until then
 * they counted as "body", response.json() failed on the empty answer and the page
 * said "Core could not be reached" after a request that had succeeded - eleven
 * hub controllers answer 204, publishing news among them.
 */
export type FetchOutcome =
    | { kind: "body" }
    | { kind: "empty" }
    | { kind: "retry" }
    | { kind: "failed"; status: number; reason: string };

export function decideResponse(status: number, mayRetry: boolean): FetchOutcome {
    if (status === 204 || status === 205) return { kind: "empty" };
    if (status >= 200 && status < 300) return { kind: "body" };
    if (status === 401 && mayRetry) return { kind: "retry" };
    return { kind: "failed", status: status, reason: reasonForStatus(status) };
}

export function reasonForStatus(status: number): string {
    if (status === 401) return "Not signed in, or the session has expired";
    if (status === 403) return "Not allowed to do that";
    if (status === 404) return "The hub does not know this address";
    if (status === 405) return "The hub does not offer this call";
    if (status === 0) return "The hub could not be reached";
    if (status >= 500) return "The hub reported an internal error";
    return "Unexpected answer (HTTP " + status + ")";
}

export function myfetchThunk(
    withtokenrecheck:boolean,
    fullurl:string, 
    payload:any,
    requesttype:'POST'|"GET"|"UPDATE"|"DELETE"|"PUT" ,
    successcb:(ResponsePayload:any) => void , 
    errocb:(ResponsePayload:any) => void,
    emptycb:() => void = () => {},
): (dispatch: Dispatch<any>, getState: () => RootState) => void{
    return (dispatch, getState) => {
        const token = getState().LoginManager.model.token;

        let requestMethod:{[key:string]:any} = {
            method:requesttype,
            headers: 
            'formData' in payload ?  {'Authorization': 'Bearer ' + token} :
            {
                "Content-Type": "text/json",
                //'content-type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + token,
            },
        };
        if (requesttype === 'GET'){
            requestMethod.body=null;
        }
        else 
        {
            requestMethod.body=JSON.stringify(payload);
        }

        if ('formData' in payload )
        {
            console.log("Found File, will set header to FormFile");
            //delete requestMethod.headers['Content-Type'];
            //requestMethod.headers['Content-Type'] = 'multipart/form-data';
           // requestMethod.headers['content-type'] = 'multipart/form-data;charset=UTF-8';
            requestMethod.body=payload.formData;
            console.log(requestMethod.body);
        }
        console.log(fullurl);
        console.log(payload);
        fetch(fullurl, requestMethod)
        .then(async (response:Response) => {
            const outcome = decideResponse(response.status, withtokenrecheck === true);

            if (outcome.kind === "body") {
                return readBody(response);
            }

            if (outcome.kind === "empty") {
                return null;
            }

            if (outcome.kind === "retry") {
                // Try once more with a fresh token; the second refusal counts.
                dispatch(myfetchThunk(
                    false,
                    fullurl,
                    payload,
                    requesttype,
                    successcb,
                    errocb,
                    emptycb,
                ) as any);
                return {};
            }

            // Say that it went wrong and tell the caller; otherwise the page
            // keeps its loading state for ever.
            console.log("Request failed", requesttype, fullurl, outcome.status, outcome.reason);
            message.error(outcome.reason);
            errocb({ status: outcome.status, reason: outcome.reason });
            return {};
        })
        .then(
            (payload:any)=>{
                //console.log("PAYLOAD RUN:",payload);
                if (payload === null) {
                    emptycb();
                    return;
                }
                if (payload != null){
                    if (Object.keys(payload).length !== 0){
                        //console.log(payload);
                        successcb(payload)};
                    }
            },
            (problem:any)=>{console.log("Could not parse responsebody as JSON",problem);
        
            const warning = () => {
                message.warning('Core could not be reached');
              };
              warning();
            // notification.open({
            //     message: 'Unexpected response',
            //     description:
            //         'There was an error in the response data strucutre. Please improve this message //TODO',
            //     onClick: () => {
            //         console.log('Notification Clicked!');
            //     },
            // });
            }
        )
    }
    
}